import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=c2f9dad4&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"
import style0 from "./EditCustomer.vue?vue&type=style&index=0&id=c2f9dad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f9dad4",
  null
  
)

export default component.exports